module.exports = __webpack_public_path__ + "img/STERiGLIDE_00_02.c71fd5ee.png";